var $ = require('jQuery');

module.exports = function() {
    var currencySymbols = currencySymbolMap.clarify();
    var currencyField = $('#currency');

    var updateCurrencySymbol = function () {
        var code = currencyField.val();
        var symbol = currencySymbols.hasOwnProperty(code) ? currencySymbols[code] : code;
        $('#currency-symbol').text(symbol);
    };

    updateCurrencySymbol();
    $('#currency').on('change', updateCurrencySymbol);
};
